import "firebase/compat/firestore";
import moment from "moment";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { createAdminNotification } from "../../../utils/notificationService";
import { useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { getPurchaseOrdersReturnOrders } from "../../../api/pagination";
import {
    orderStatuses,
    paymentStatuses,
    returnStatus,
    returnStatusShip,
} from "../../../data";
import {
    addToArray,
    generateCustomID,
    getDocByKeyValue,
    getAllOfCollection,
    saveData,
    uniqueID,
    uploadingFiles,
    uploadingImages
} from "../../../firebase/utility";
const useReturnSaleOrder = () => {
    const location = useLocation();
    const { order, isEdit } = location.state || {};
    const { id } = useParams()
    const history = useHistory();
    const [creationDate, setCreationDate] = useState(moment(order?.date_created).format("YYYY-MM-DD") ?? "")
    const { all_products } = useSelector((state) => state.products);
    const { all_vendors } = useSelector((state) => state.orders);
    const { user } = useSelector((state) => state.auth);
    const [orderData, setOrderData] = useState(order ?? null)
    const [uploadedLabel, setUploadedLabel] = useState(null);
    const [labelImages, setLabelsImages] = useState(orderData?.labelImages ?? [])
    // GENERAL STATES ++++++++++++++++++++++++++++++++++++++++++++
    const [note, setNote] = useState("");
    const [totalAmount, setTotalAmount] = useState(orderData?.total ?? 0);
    const [orderNotes, setOrderNotes] = useState(orderData?.returnOrderNotes ?? [{
        createdAt: Date.parse(new Date()),
        createdBy: user,
        message: "Return Order has been Created",
    }]);
    const [subTotal, setSubTotal] = useState(orderData?.subTotal ?? 0);
    const [billingData, setBillingData] = useState({});
    const [shippingData, setShippingData] = useState({});
    const [orderNumber, setOrderNumber] = useState(orderData?.number ?? "");
    const [totalTax, setTotalTax] = useState(0);
    const [loader, setLoader] = useState(false);
    const [returnOrder, setReturnOrder] = useState(true)
    const [shippingCheckboxes, setShippingCheckboxes] = useState(
        orderData?.shippingCheckboxes ?? {
            sms_disabled: false,
            residiential: false,
            do_not_email: false,
            ship_partially: false,
        }
    );
    const [line_items, setLineItems] = useState(orderData?.line_items ?? []);
    const [new_line_items, setNewLineItems] = useState([]);
    const [poDetails, setPoDetails] = useState([]);
    const [totalTaxAmount, setTotalTaxAmount] = useState({
        shippingAmount: orderData?.totalTaxAmount?.shippingAmount ?? 0,
        insurance: orderData?.totalTaxAmount?.insurance ?? 0,
        discount: orderData?.totalTaxAmount?.discount ?? 0,
        tax: orderData?.totalTaxAmount?.tax ?? 0,
    });
    const [dataLoading, setDataLoading] = useState(false)
    const [checks, setchecks] = useState(true);
    const [tm, setTm] = useState(true);
    const [usAddresses, setUsAddresses] = useState([]);
    const [selectedUSAddressId, setSelectedUSAddressId] = useState("");

    useEffect(() => {
        getAllOfCollection("USAddresses").then((res) => {
            setUsAddresses(res || []);
            if (res && res.length > 0) {
                setSelectedUSAddressId(res[0]._id || res[0].id);
            }
        });
    }, []);
    const [addVendor, setAddVendor] = useState(false);
    // MODALS STATES AND FUNCTIONS +++++++++++++++++++++++++++++++++++++++++++++
    const [itemModal, setItemModal] = useState(false);
    const toggleItemModal = () => {
        setItemModal(!itemModal);
    };
    const [shippingModal, setShippingModal] = useState(false);
    const toggleShippingModal = () => {
        setShippingModal(!shippingModal);
    };
    const [orderStatus, setOrderStatus] = useState(
        orderStatuses.find((i) => i.label === orderData?.status)?.label ?? ""
    );
    const toggleAddVendor = () => {
        setAddVendor(!addVendor);
    };
    const [paymentStatus, setPaymentStatus] = useState(
        paymentStatuses.find((i) => i.label === orderData?.paymentStatus) ?? ""
    );
    const [return_status, set_return_status] = useState(
        returnStatus.find((i) => i.value === orderData?.return_status)?.value ?? "Return Created"
    );
    const [shipBy, setShipBy] = useState(
        returnStatusShip.find((i) => i.value === orderData?.shipBy)?.value ?? ""
    );
    // FUNCTIONS +++++++++++++++++++++++++++++++++++++++++++++++
    const calculateTotal = async () => {
        let calculate_total_amount =
            parseFloat(subTotal ?? 0) +
            (parseFloat(orderData?.total ?? 0) / 100) *
            parseFloat(totalTaxAmount?.tax ?? 0) +
            parseFloat(totalTaxAmount?.shippingAmount) +
            parseFloat(totalTaxAmount?.insurance) -
            parseFloat(totalTaxAmount?.discount);
        setTotalAmount(calculate_total_amount.toFixed(2));
    };
    const handleSubmitOrder = async () => {
        setLoader(true);
        let arr;
        if (labelImages?.length > 0) {
            arr = await uploadingFiles(labelImages ?? [], "Return_order_labels");
        }
        const obj = {
            billing: billingData,
            shipping: shippingData,
            uid: isEdit ? orderData?.uid : await generateCustomID("ReturnOrders", "id"),
            id: orderData?.id,
            number: orderNumber,
            total: totalAmount,
            return_status,
            shipBy: shipBy ?? "",
            subTotal,
            line_items: line_items ?? [],
            totalTaxAmount,
            status: orderStatus ?? "New",
            // _id: orderData.saleOrderId ? orderData?._id : uniqueID(),
            _id: isEdit ? orderData?._id : uniqueID(),
            saleOrderId: orderData.saleOrderId ? orderData?.saleOrderId : orderData?._id,
            date_created: orderData?.date_created ?? Date.parse(new Date()),
            shippingCheckboxes: shippingCheckboxes,
            customer_id: shippingData?.quickbooks_id ?? orderData?.customer_id,
            paymentStatus: orderData?.paymentStatus ?? "Pending Payment",
            returnOrderNotes: orderNotes ?? [],
            comingToTM: tm,
            labelImages: arr ?? [],
            vendor: orderData?.vendor ?? {}
        };
        saveData("ReturnOrders", obj?._id, obj).then((res) => {
            toast.success("Return Order Saved Successfully");
            createAdminNotification({
                title: "Return Order Saved",
                message: `Return order for #${obj?.number || obj?.id || id} was saved by ${user?.username || "Admin"}`,
                category: "order",
                entityId: String(obj?.number || obj?.id || id),
                targetUrl: `/admin/return-orders`,
                actor: user,
            }).catch(console.error);
            setLoader(false);
        });
    };
    const addOrderNote = () => {
        if (note !== "") {
            let obj = {
                createdAt: Date.parse(new Date()),
                createdBy: user,
                message: note,
            };
            addToArray("ReturnOrders", id, "returnOrderNotes", obj);
            setOrderNotes([...orderNotes, obj]);
            setNote("");
        } else {
            toast.error("Please add note to proceed !");
        }
    };
    const backToSaleOrder = () => {

        history.push({
            pathname: `/admin/sale-order-details/${order?.saleOrderId}`,
            order: { ...orderData, fromRO: true },
        });
    }
    // USEEFFECT HOOKS ++++++++++++++++++++++++++++++++++++++++++++++++
    useEffect(() => {
        let totalTaxRate =
            (parseFloat(subTotal ?? 0) / 100) * parseFloat(totalTaxAmount?.tax ?? 0);
        setTotalTax(totalTaxRate);
    }, [totalTaxAmount]);
    useEffect(() => {
        let subtotal = 0;
        line_items?.forEach((item) => {
            const quantity = parseInt(item.quantity ?? 0);
            const price = parseFloat(item.price ?? 0);
            subtotal += quantity * price;
        });
        setSubTotal(subtotal?.toFixed(2));
        setTotalAmount(subtotal?.toFixed(2));
    }, [line_items]);
    useEffect(() => {
        calculateTotal();
    }, [totalTaxAmount, line_items, subTotal]);
    useEffect(() => {
        if (orderData) {
            setShippingData({
                company: orderData?.shipping?.company ?? "",
                first_name: orderData?.shipping?.first_name ?? "",
                last_name: orderData?.shipping?.last_name ?? "",
                address_1: orderData?.shipping?.address_1 ?? "",
                address_2: orderData?.shipping?.address_2 ?? "",
                city: orderData?.shipping?.city ?? "",
                country: orderData?.shipping?.country ?? "",
                state: orderData?.shipping?.state ?? "",
                phone: orderData?.shipping?.phone ?? "",
                postcode: orderData?.shipping?.postcode ?? "",
                email: orderData?.shipping?.email ?? "",
            });
            setBillingData({
                company: orderData?.billing?.company ?? "",
                first_name: orderData?.billing?.last_name ?? "",
                last_name: orderData?.billing?.last_name ?? "",
                address_1: orderData?.billing?.address_1 ?? "",
                address_2: orderData?.billing?.address_2 ?? "",
                city: orderData?.billing?.city ?? "",
                country: orderData?.billing?.country ?? "",
                state: orderData?.billing?.state ?? "",
                phone: orderData?.billing?.phone ?? "",
                postcode: orderData?.billing?.postcode ?? "",
                email: orderData?.billing?.email ?? "",
            });
        }
    }, [orderData]);
    useEffect(() => {
        if (!orderData) return;
        if (tm) {
            const addr = usAddresses.find(a => (a._id === selectedUSAddressId || a.id === selectedUSAddressId)) || usAddresses[0];
            if (addr) {
                setShippingData({
                    first_name: addr.first_name || "",
                    last_name: addr.last_name || "",
                    address_1: addr.address_1 || "",
                    address_2: addr.address_2 || "",
                    company: addr.company || "",
                    country: addr.country || "USA",
                    state: addr.state || "",
                    email: addr.email || "",
                    city: addr.city || "",
                    postcode: addr.postcode || "",
                    phone: addr.phone || "",
                    quickbooks_id: addr.quickbooks_id || "",
                });
            } else {
                const tmInfo = {
                    first_name: "Receiving",
                    last_name: "Department",
                    address_1: "206 Far Hill Drive",
                    address_2: "",
                    company: "TechMicro USA INC",
                    country: "USA",
                    state: "IL",
                    email: "purchasing@techmicrousa.com",
                    city: "Bolingbrook",
                    postcode: "60440",
                    phone: "6305261800",
                    quickbooks_id: "613",
                };
                setShippingData(tmInfo);
            }
        } else {
            const vendorInfo = {
                company: orderData?.vendor?.company ?? orderData?.shipping?.company ?? "",
                first_name: orderData?.vendor?.first_name ?? orderData?.shipping?.first_name ?? "",
                last_name: orderData?.vendor?.last_name ?? orderData?.shipping?.last_name ?? "",
                address_1: orderData?.vendor?.address_1 ?? orderData?.shipping?.address_1 ?? "",
                address_2: orderData?.vendor?.address_2 ?? orderData?.shipping?.address_2 ?? "",
                city: orderData?.vendor?.city ?? orderData?.shipping?.city ?? "",
                country: orderData?.vendor?.country ?? orderData?.shipping?.country ?? "",
                state: orderData?.vendor?.state ?? orderData?.shipping?.state ?? "",
                phone: orderData?.vendor?.phone ?? orderData?.shipping?.phone ?? "",
                postcode: orderData?.vendor?.postcode ?? orderData?.shipping?.postcode ?? "",
                email: orderData?.vendor?.email ?? orderData?.shipping?.email ?? "",
            };
            setShippingData(vendorInfo);
        }
    }, [tm, orderData, selectedUSAddressId, usAddresses]);
    useEffect(() => {
        if (orderData?.saleOrderId) {
            setLineItems(orderData?.line_items ?? []);
            setDataLoading(true)
            getPurchaseOrdersReturnOrders(orderData?.saleOrderId, (res) => {
                if (res?.data?.data) {
                    setPoDetails(res?.data?.data);
                }
                // Always set loading to false, whether we got data or not
                setDataLoading(false);
            })
        } else {
            // If no saleOrderId, ensure loading is false
            setDataLoading(false);
        }
    }, [orderData]);



    // Fetch return order details when component mounts using the _id from URL
    useEffect(() => {
        if (order?.uid) {
            // id from URL params is the _id of the return order
            getDocByKeyValue("ReturnOrders", "uid", order?.uid).then((res) => {
                if (res && res.length > 0) {
                    const returnOrderData = res[0]; // getDocByKeyValue returns an array
                    console.log(returnOrderData)
                    setOrderData(returnOrderData);
                    setTm(returnOrderData?.comingToTM ?? true);
                    setOrderNotes(returnOrderData?.returnOrderNotes ?? []);
                    setLabelsImages(returnOrderData?.labelImages ?? []);
                }
            });
        }
    }, [order?.uid])

    useEffect(() => {
        if (order) {
            setOrderData(order ?? {})
        }
    }, [order])
    return {
        toggleItemModal,
        itemModal,
        shippingModal,
        toggleShippingModal,
        billingData,
        setBillingData,
        shippingData,
        setShippingData,
        orderStatus,
        setOrderStatus,
        paymentStatus,
        setPaymentStatus,
        setOrderNotes,
        totalTaxAmount,
        setTotalTaxAmount,
        subTotal,
        totalAmount,
        orderNumber,
        setOrderNumber,
        set_return_status,
        return_status,
        shipBy,
        setShipBy,
        all_products,
        line_items,
        setLineItems,
        note,
        setNote,
        addOrderNote,
        all_vendors,
        shippingCheckboxes,
        setShippingCheckboxes,
        uploadingImages,
        handleSubmitOrder,
        poDetails,
        order,
        orderNotes,
        new_line_items,
        setNewLineItems,
        returnOrder, setReturnOrder,
        checks,
        tm, setTm, usAddresses, selectedUSAddressId, setSelectedUSAddressId,
        totalTax, dataLoading,
        loader, creationDate, setOrderNotes, setCreationDate, history, backToSaleOrder, orderData, setUploadedLabel, setLabelsImages, labelImages,
        addVendor, setAddVendor, toggleAddVendor
    };
};
export default useReturnSaleOrder;
